import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { IPositionBookPromiseLookupService } from "../IPositionBookPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { PositionBookLookupService } from "./PositionBookLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class PositionBookReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.PositionBookImpl>
  implements IPositionBookPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.PositionBookImpl,
      "PositionBookImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new PositionBookLookupService(),
    );
  }

  getPositionBook(code: string): Promise<CubiqTS.PositionBookImpl> {
    let request = new UiArguments("getPositionBook");
    let arg1 = new FnArg(code, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getAdaptedPositionBook(code: string): Promise<any> {
    let request = new UiArguments("getAdaptedPositionBook");
    let arg1 = new FnArg(code, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getAdaptedPositionBooks(query: string): Promise<Array<any>> {
    let request = new UiArguments("getAdaptedPositionBooks");
    let arg1 = new FnArg(query, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getPositionBooks(query: string): Promise<Array<CubiqTS.PositionBookImpl>> {
    let request = new UiArguments("getPositionBooks");
    let arg1 = new FnArg(query, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getAdaptedUserDefaultPositionBook(): Promise<any> {
    let request = new UiArguments("getAdaptedUserDefaultPositionBook");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getUserDefaultPositionBook(): Promise<CubiqTS.PositionBookImpl> {
    let request = new UiArguments("getUserDefaultPositionBook");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  getPositionBooksForPairAndTradingGroup(
    base: string,
    nonBase: string,
    traderGroupId: number,
    vehicleCcy?: string,
  ): Promise<any> {
    let request = new UiArguments("getPositionBooksForPairAndTradingGroup");
    let arg1 = new FnArg(base, PRIMITIVE);
    let arg2 = new FnArg(nonBase, PRIMITIVE);
    let arg3 = new FnArg(traderGroupId, PRIMITIVE);
    let arg4 = new FnArg(vehicleCcy, PRIMITIVE);
    request.args = [arg1, arg2, arg3, arg4];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getPositionBooksForPairAndUserBranch(base: string, nonBase: string): Promise<Array<any>> {
    let request = new UiArguments("getPositionBooksForPairAndUserBranch");
    let arg1 = new FnArg(base, PRIMITIVE);
    let arg2 = new FnArg(nonBase, PRIMITIVE);
    request.args = [arg1, arg2];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getPositionBooksForPairAndBranch(
    base: string,
    nonBase: string,
    branchCd: string,
  ): Promise<Array<any>> {
    // DOES NOTHING
    return null;
  }
}
